module.exports = __webpack_public_path__ + "static/media/perfilImgIcon.77ce0d89.svg";